var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.textColor},[_vm._v("Q"+_vm._s(_vm.presenter.quarter))])
}
var staticRenderFns = []

export { render, staticRenderFns }